<template>
  <b-row>
    <b-col
      lg="auto"
      cols="12"
      class="ml-0 ml-lg-4 mb-3 mb-lg-0 mt-0 mt-lg-4"
    >
      <div style="height: 9px;" />
      <toggle-button
        v-model="client.inUse"
        :disabled="!platform.inUse"
        :height="24"
        :width="60"
        :sync="true"
        class="mb-0 mr-2"
      />
      <div
        :disabled="!platform.inUse"
        style="display: inline-block; width: 150px;"
      >
        {{ client.displayName }}
      </div>
    </b-col>
    <b-col
      lg
      class="mb-3 mb-lg-0"
    >
      <b-form-group
        class="o-field"
      >
        <label
          :for="'clientId' + platformIndex + '-' + clientIndex"
          :disabled="!client.inUse"
          class="text-truncate"
        >Client ID</label>
        <b-form-input
          :id="'clientId' + platformIndex + '-' + clientIndex"
          v-model="client.clientId"
          :disabled="!client.inUse"
          :required="client.inUse"
          :state="clientIdValid"
          spellcheck="false"
        />
        <div class="invalid-tooltip">
          {{ clientIdFeedback }}
        </div>
      </b-form-group>
    </b-col>
    <b-col
      lg
    >
      <b-form-group
        v-if="client.requireClientSecret"
        class="o-field"
      >
        <label
          :for="'clientSecret' + platformIndex + '-' + clientIndex"
          :disabled="!client.inUse"
          class="text-truncate"
        >Client Secret</label>
        <b-form-input
          :id="'clientSecret' + platformIndex + '-' + clientIndex"
          v-model="client.clientSecret"
          :type="settings.showSecrets ? 'text' : 'password'"
          :disabled="!client.inUse"
          :required="client.inUse"
          :state="clientSecretValid"
          spellcheck="false"
        />
        <div class="invalid-tooltip">
          {{ clientSecretFeedback }}
        </div>
      </b-form-group>

      <b-form-group
        v-if="clientIsWebDispatch"
        class="o-field"
      >
        <label
          :for="'clientWDUrl' + platformIndex + '-' + clientIndex"
          :disabled="!client.inUse"
          class="text-truncate"
        >WebDispatch Uri</label>
        <b-form-input
          :id="'clientWDUrl' + platformIndex + '-' + clientIndex"
          v-model="client.webDispatchUri"
          :disabled="!client.inUse"
          :required="client.inUse"
          :state="clientWebDispatchValid"
          spellcheck="false"
        />
        <div class="invalid-tooltip">
          {{ clientWebDispatchFeedback }}
        </div>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    platform: {
      type: Object,
      required: true
    },
    platformIndex: {
      type: Number,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    clientIndex: {
      type: Number,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  computed: {
    clientIdValid() {
      return !this.client.inUse || this.client.clientId.length > 0 ? true : false;
    },
    clientIdFeedback() {
      return this.clientIdValid ? "" : "Required";
    },
    clientSecretValid() {
      return !this.client.inUse || this.client.clientSecret.length > 0 || !this.client.requireClientSecret ? true : false;
    },
    clientSecretFeedback() {
      return this.clientSecretValid ? "" : "Required";
    },
    clientIsWebDispatch() {
      return this.client.clientName === "WebDispatch";
    },
    clientWebDispatchValid() {
      return !this.client.inUse || this.client.webDispatchUri.length > 0;
    },
    clientWebDispatchFeedback() {
      return this.clientWebDispatchValid ? "" : "Required";
    },
    suffix() {
      let suffixUrl = "";
      if (window.location.origin.includes("localhost"))
        suffixUrl = ".webdispatch.local:7257";
      else if (window.location.origin.includes("-dev"))
        suffixUrl = ".webdispatch-dev.omnigo.one";
      else if (window.location.origin.includes("-qa"))
        suffixUrl = ".webdispatch-dev.omnigo.one";
      else if (window.location.origin.includes("-demo"))
        suffixUrl = ".webdispatch-demo.omnigo.one";
      else
        suffixUrl = ".dispatch.omnigo.one";

      return suffixUrl;
    }
  },
  watch: {
    "client.inUse": function(val) {
      if (val) {
        this.client.clientId = this.generateId();
        this.client.clientSecret = this.client.requireClientSecret ? this.generateSecret() : "";
        if (this.clientIsWebDispatch && this.platform.baseUrl && this.platform.baseUrl.indexOf(".") > 0){
          let subdomain = this.platform.baseUrl.replace("https://", "").replace("http://", "");
          if (subdomain.indexOf(".") > 0) {
            subdomain = subdomain.substring(0, subdomain.indexOf("."));
          }
          this.client.webDispatchUri = "https://" + subdomain + this.suffix;
        }
        return;
      }

      this.client.clientId = "";
      this.client.clientSecret ="";
      this.client.webDispatchUri ="";
    }
  },
  methods: {
    generateId() {
      return this.$uuid.v4().replace(/-/g, "").toUpperCase();
    }
  }
}
</script>